<template>
  <div class="show">
    <!-- header -->
    <header-bar :selected="selected" :cityName="cityName" @getCityId="getCityId"></header-bar>
    <!-- banner -->
    <div class="banner-wrapper">
      <div class="banner">
        <div class="banner-l">
          <div class="avatar-shadow"><img :src="movieInfo.poster"></div>
        </div>
        <div class="banner-r">
          <h1 class="name">{{cinemaDetail.name}}</h1>
          <div class="address">{{cinemaDetail.address}}</div>
          <div class="tel" v-if="cinemaDetail.phone">电话：{{cinemaDetail.phone}}</div>
          <div class="features-group" v-if="cinemaDetail.features!=null">
            <div class="group-title">影院服务</div>
            <template v-for="(item, index) in cinemaDetail.features">
              <div class="feature" :key="index" v-if="index < 5">
                <span class="tag">{{item.featureName}}</span>
                <span class="desc">{{item.featureDesc}}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- container -->
    <div class="container">
      <!-- 面包屑 -->
      <div class="crumbs-nav-container">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">看购电影</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/cinemaList' }">影院</el-breadcrumb-item>
          <el-breadcrumb-item>{{cinemaDetail.name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 影片列表 -->
      <el-carousel indicator-position="none" arrow="always" :autoplay=false :loop=false ref="carouselShow" @change="changeCarousel">
        <el-carousel-item v-for="(item, index) in newArray" :key="index">
          <div class="item-wrapper">
            <template v-for="(item1, idx) in item">
              <div class="" :class="['img-wrapper', ((swiperArrayCurrent==index) && (swiperCurrent==idx))?'active':'']"  :key="idx" v-if="typeof(item1)=='string'">
                <img name="car-img" id="car-img" class="car-img" :src="item1" @click="setActive(index, idx)" :style="'height:' + carImgH" ref="carimgs"/>
                <span class="pointer"></span>
              </div>
            </template>
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- 排期 -->
      <div class="show-list">
        <!-- 影片信息 -->
        <div class="movie-info">
          <div class="header">
            <div class="name">{{movieInfo.title}}</div>
            <div class="score">{{movieInfo.scores}}<span class="unit">分</span></div>
          </div>
          <div class="desc">
            <div class="item">
              <span class="key">时长 :</span>
              <span class="value">{{movieInfo.time}}分钟</span>
            </div>
            <div class="item">
              <span class="key">类型 :</span>
              <span class="value">{{movieInfo.types}}</span>
            </div>
            <div class="item">
              <span class="key">主演 :</span>
              <span class="value">{{movieInfo.player}}</span>
            </div>
          </div>
        </div>
        <!-- 观影时间 -->
        <div class="show-date">
          <span class="txt">观影时间 :</span>
          <span :class="['date-item', showCurrent==index?'active':'']" v-for="(item,index) in showList" :key="index"
                @click="titleTab(index)">{{item.time}}</span>
        </div>
        <!-- 排期列表 -->
        <div class="plist-container">
          <table class="plist">
            <thead>
              <tr>
                <th>放映时间</th>
                <th>语言版本</th>
                <th>放映厅</th>
                <th>售价（点）</th>
                <th>选座购票</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in dateShowList" :key="index">
                <td>
                  <span class="begin-time">{{item.time}}</span><br/>
                  <span class="end-time">{{item.endtime}}散场</span>
                </td>
                <td>
                  <span class="lang">{{item.film_language}}{{item.film_dimensional}}</span>
                </td>
                <td>
                  <span class="hall">{{item.hallName}}</span>
                </td>
                <td>
                  <!-- ￥ -->
                  <span class="sell-price" v-if="item.minPrice!=0"><span class="price">{{item.minPrice}}点</span></span>
                </td>
                <td>
                  <span class="buy-btn" @click="toSeats(item.id, item.minPrice)">选座购票</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import headerBar from '@/components/headerBar'
  import footerBar from '@/components/footerBar'
  import {getCinemaDetail} from '@/api/cinema'
  import {getShowFilmList, getDateShowList} from '@/api/film'

  export default {
    components: {headerBar, footerBar},
    data(){
      return{
        // 参数--影片id
        mid: this.$route.query.mid,
        // 参数--影院id
        cid: this.$route.query.cid,
        // 选中的当前导航
        selected: "",
        // 城市名称
        cityName: '',
        // 影院信息
        cinemaDetail: {},
        // 是否展开剧情介绍
        zhankai: false,
        // 影片列表
        movieList: [],
        // 影片信息
        movieInfo: {},
        // 新影片轮播第几数组
        swiperArrayCurrent: 0,
        // 新影片轮播下标
        swiperCurrent: 0,
        // 新影片数组
        newArray: [],
        //当前场次日期下标
        showCurrent: 0,
        //场次列表
        showList: [],
        //场次时间列表
        dateShowList: [],
        //是否显示无场次信息
        isShowData: false,
        // 影片海报图高度
        carImgH: ''
      }
    },
    mounted() {
      //保证this实例已经插入文档
      this.$nextTick(function(){
        // 设置影片海报图动态高度
        let carImgW = parseInt((this.$refs.carouselShow.$el.clientWidth-40)/7);//图片宽度
        this.carImgH = parseInt((500/357)*carImgW) + 'px';//根据比例获取图片高度
        // 默认滚动条在最上面
        window.scrollTo(0,0);
        // 获取城市名称
        this.cityName = localStorage.getItem('cityName');
        // 获取影院信息
        this.getCinemaDetail();
        // 获取影片列表
        this.getShowFilmList();
      })
    },
    methods: {
      // 获取子组件（headerBar）传递的值
      getCityId(cityId){
        this.cityId = cityId;
        this.cityName = localStorage.getItem("cityName");
      },
      // 获取影院信息
      getCinemaDetail() {
      	let signdata = {cid: this.cid};
        let data = {cid: this.cid, signdata: signdata};
        getCinemaDetail(data).then(response => {
          this.cinemaDetail = response.data;
        });
      },
      // 获取影片列表
      getShowFilmList() {
      	let signdata = {cid: this.cid};
        let data = {cid: this.cid, signdata: signdata};
        getShowFilmList(data).then(response => {
          // 影片列表
          this.movieList = response.data;
          // 影片轮播列表
          this.newArray = this.formatArray(this.movieList, 7);
          if (this.mid == undefined) {
            this.mid = this.movieList[0].mid;
            this.movieInfo = this.movieList[0];
            // 新影片轮播第几数组
            this.swiperArrayCurrent = 0;
            // 新影片轮播下标
            this.swiperCurrent = 0;
          } else {
            for (let i in this.movieList) {
              //遍历列表数据      
              if (this.movieList[i].mid == this.mid) {
                this.movieInfo = this.movieList[i];
                // 新影片轮播第几数组(取商)
                this.swiperArrayCurrent = parseInt(i/7);
                // 新影片轮播下标(取余数)
                this.swiperCurrent = parseInt(i%7);
                // 手动切换幻灯片 参数：需要切换的幻灯片的索引
                if(this.swiperArrayCurrent > 0){
                  this.$refs.carouselShow.setActiveItem(this.swiperArrayCurrent);
                }
                break;
              }
            }
          }
          // 获取场次时间列表
          this.getDateShowList();
        });
      },
      // 获取场次时间列表
      getDateShowList() {
      	let signdata = {cid: this.cid, mid: this.mid};
        let data = {cid: this.cid, mid: this.mid, signdata: signdata};
        getDateShowList(data).then(response => {
          let showList = response.data;
          if(null != showList && showList.length > 0){
            this.dateShowList = showList[0].show;
            if (this.dateShowList.length > 0) {
              this.isShowData = true;
            }
          }
          this.showList = showList;
        });
      },
      // 展开剧情介绍
      openDesc(){
        this.zhankai = true;
      },
      // 收起剧情介绍
      closeDesc(){
        this.zhankai = false;
      },
      // 新影片数组 [1,2,3,4,5,6,7,8,9]转换为[[1,2,3,4,5,6,7],[8,9]]
      formatArray(arr,num){
        var newArray = new Array(Math.ceil(arr.length / num));
        for(var i =0; i<newArray.length; i++){
          newArray[i] = [];
          for(var j=0;j<num; j++){
            newArray[i][j] = {};
          }
        }
        for(var i =0; i<arr.length; i++){
          if(arr[i].poster){
            newArray[parseInt(i/num)][i%num]= arr[i].poster;
          }
        }
        return newArray;
      },
      // 选中影片
      setActive(index, idx){
        // 新影片轮播第几数组
        this.swiperArrayCurrent = index;
        // 新影片轮播下标
        this.swiperCurrent = idx;
        this.movieInfo = this.movieList[index*7 + idx];
        this.mid = this.movieInfo.mid;
        this.showCurrent = 0;
        this.showList = [];
        this.dateShowList = [];
        // 获取场次时间列表
        this.getDateShowList();
      },
      // 幻灯片切换时触发 默认选中为第一个
      changeCarousel: function(newIndex, oldIndex) {
        // if(newIndex-oldIndex>0){
        //   // 新影片轮播第几数组
        //   this.swiperArrayCurrent = this.swiperArrayCurrent + 1;
        // }else{
        //   // 新影片轮播第几数组
        //   this.swiperArrayCurrent = this.swiperArrayCurrent - 1;
        // }
        // // 新影片轮播下标
        // this.swiperCurrent = 0;
        // this.movieInfo = this.movieList[newIndex*7];
        // this.mid = this.movieInfo.mid;
        // this.showCurrent = 0;
        // this.showList = [];
        // this.dateShowList = [];
        // // 获取场次时间列表
        // this.getDateShowList();
      },
      // 场次时间tab切换
      titleTab(index){
        this.showCurrent = index;
        let dateShowList = [];
        let Todaydare = this.showList[index].show;
        for (let i in Todaydare) {
          //遍历列表数据      
          if (Todaydare[i].mid == this.mid) {
            //根据下标找到目标,改变状态  
            dateShowList.push(Todaydare[i])
          }
        }
        this.dateShowList = dateShowList;
        if (this.dateShowList.length > 0) {
          this.isShowData = true;
        }
      },
      // 选座购票
      toSeats(sid, price){
        if(price==0){
          //首页地址
          let homeUrl = process.env.BASE_API + "/#/";
          //encodeURI
          let bussUrl = encodeURIComponent(homeUrl);
          //登录地址
          location.href = process.env.LOGIN_URL + "/weblogin.html#/?redirect_uri=" + bussUrl;
        }else{
          this.$router.push({path: '/seat', query: {sid: sid}})
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .show .banner-wrapper{
    margin-top: 80px;
    width: 100%;
    background: url('../assets/images/film-detail-bg.png') repeat 50%;
  }
  .show .banner{
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 0 auto;
    width: 75%;
    height: 376px;
  }
  .show .banner .banner-l {
    width: 30%;
    position: relative;
    top: 70px;
    z-index: 9;
    overflow: hidden;
  }
  .show .banner .banner-l .avatar-shadow {
    position: relative;
    /*margin: 0 30px;*/
    width: 100%;
    height: 330px;
    padding-bottom: 40px;
    box-sizing: border-box;
    background: url('../assets/images/film-detail-img-b.png') no-repeat bottom;
  }
  .show .banner .banner-l .avatar-shadow img{
    display: block;
    border: 4px solid #fff;
    height: 322px;
    width: 232px;
  }
  .show .banner .banner-r {
    flex: 1;
    padding-left: 2%;
    margin-right: 30px;
    margin-top: 70px;
    text-align: left;
    color: #fff;
  }
  .show .banner .banner-r .name{
    margin: 0;
    font-size: 26px;
    margin-bottom: 9px;
    font-weight: 400;
  }
  .show .banner .address {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .show .banner .tel{
    margin-bottom: 20px;
  }
  .show .banner .features-group {
    position: relative;
  }
  .show .banner .features-group .group-title {
    font-size: 14px;
    margin-bottom: 5px;
    overflow: hidden;
    width: 410px;
  }
  .show .banner .features-group .group-title:after {
    border-top: 1px solid hsla(0,0%,100%,.7);
    display: block;
    content: "";
    position: relative;
    top: -10px;
    left: 70px;
  }
  .show .banner .features-group .feature {
    font-size: 12px;
    margin-bottom: 2px;
    position: relative;
    min-height: 22px;
    line-height: 23px;
    -webkit-transform-origin: 0;
    -ms-transform-origin: 0;
    transform-origin: 0;
    -webkit-transform: scale(.8);
    -ms-transform: scale(.8);
    transform: scale(.8);
  }
  .show .banner .features-group .feature .tag {
    display: inline-block;
    border: 1px solid hsla(0,0%,100%,.6);
    border-radius: 2px;
    min-width: 60px;
    height: 22px;
    line-height: 23px;
    text-align: center;
  }
  .show .bannner .features-group .feature .desc {
    display: inline-block;
    max-width: 438px;
    margin-left: 5px;
    vertical-align: middle;
  }
  .show .container {
    margin-top: 120px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 30px;
    width: 75%;
  }
  /*面包屑*/
  .show .crumbs-nav-container {
    margin-top: -55px;
    margin-bottom: 25px;
    font-size: 14px;
    color: #666;
  }
  /*影片列表*/
  .show .el-carousel__arrow{
    opacity: .6;
    background-color: none;
  }
  .show .el-carousel .item-wrapper{
    margin: 0 auto;
    padding: 40px 20px;
    display: flex;
    align-items: center;
    background: #efefef;
  }
  .show .item-wrapper .img-wrapper{
    position: relative;
    display: inline-block;
    padding: 0 4px;
    width: 14.2%;
    /*height: 227px;*/
    box-sizing: border-box;
  }
  .show .item-wrapper .img-wrapper .car-img{
    display: inline-block;
    width: 100%;
    height: 206px;
    cursor: pointer;
    transform: scale(1);
    border: 4px solid #fff;
    box-sizing: border-box;
    z-index: 100;
  }
  .show .item-wrapper .img-wrapper.active .car-img{
    transform: scale(1.1);
    border-color: #f24030;
  }
  .show .item-wrapper .img-wrapper.active .pointer {
    position: absolute;
    display: block;
    content: "";
    bottom: -43px;
    left: 50%;
    margin-left: -14px;
    border-style: solid;
    border-width: 11px 14px;
    border-color: transparent transparent #fff;
  }
  /*影片信息*/
  .show .show-list .movie-info {
    margin-top: 20px;
    border-bottom: 1px solid #e5e5e5;
    text-align: left;
  }
  .show .show-list .movie-info .name {
    display: inline-block;
    margin: 0 20px 20px 0;
    font-size: 26px;
    font-weight: 400;
    color: #333;
  }
  .show .show-list .movie-info .score {
    display: inline-block;
    font-size: 24px;
    color: #faaf00;
  }
  .show .show-list .movie-info .score .unit{
    font-size: 12px;
  }
  .show .show-list .movie-info .desc .item {
    display: inline-block;
    font-size: 14px;
    color: #151515;
    margin-bottom: 20px;
    margin-right: 40px;
  }
  .show .show-list .movie-info .desc .key {
    color: #999;
  }
  /*观影时间*/
  .show .show-date{
    padding: 30px 0;
    font-size: 14px;
    color: #999;
    text-align: left;
  }
  .show .show-date .date-item {
    display: inline-block;
    background-color: transparent;
    border-radius: 100px;
    color: #333;
    padding: 2px 10px;
    margin-left: 12px;
    cursor: pointer;
  }
  .show .show-list .show-date .date-item.active {
    color: #fff;
    background-color: #f03d37;
  }
  /*排期列表*/
  .show .show-list .plist {
    width: 100%;
    border: none;
    border-spacing: 0;
  }
  .show .show-list .plist thead {
    background-color: #f7f7f7;
    color: #333;
    font-size: 16px;
    padding: 18px 0;
  }
  .show .show-list .plist thead th {
    padding: 16px 0;
  }
  .show .show-list .plist tbody tr {
    height: 82px;
  }
  .show .show-list .plist tbody td {
    text-align: center;
    width: 20%;
  }
  .show .show-list .plist tbody .begin-time {
    font-size: 18px;
    color: #333;
    font-weight: 700;
  }
  .show .show-list .plist tbody .end-time {
    font-size: 12px;
    color: #999;
  }
  .show .show-list .plist tbody .hall, 
  .show .show-list .plist tbody .lang {
    font-size: 14px;
    color: #333;
  }
  .show .show-list .plist tbody .sell-price {
    font-size: 12px;
    color: #f03d37;
    font-weight: 700;
  }
  .show .show-list .plist tbody .sell-price .price{
    font-size: 18px;
  }
  .show .show-list .plist tbody .buy-btn {
    display: inline-block;
    width: 80px;
    height: 30px;
    color: #fff;
    background-color: #f03d37;
    font-size: 14px;
    line-height: 30px;
    border-radius: 100px;
    text-align: center;
    cursor: pointer;
  }
  .show .show-list .plist tbody tr:nth-child(even){
    background-color: #f9f9f9;
  }
  /*轮播*/
.show .el-carousel__arrow{
  width: 50px !important;
  height: 50px !important;
  font-size: 36px;
  font-weight: bold;
  background-color: rgba(31,45,61,.4) !important;
}
</style>


// WEBPACK FOOTER //
// src/views/show.vue